<template>
    <div>
        <transition name="fade" appear mode="out-in" appear-active-class="fade-enter-active">
            <b-tabs align="center" content-class="mt-0 mb-0" v-model="step" justified>
                <b-row>
                    <b-col>
                        <b-tab active>
                            <DocumentImage v-if="windowSize < 992" v-bind:invoicePicture="invoicerecognitionitem.filename" 
                                    class="b-col-with-invoice-image mb-4 d-xs-block d-sm-block d-md-block d-lg-none"/>

                            <b-container class="mb-0 ml-0">
                                <b-row>
                                    <b-table-simple responsive style="width: 100%" class="d-none d-lg-block d-xl-block">
                                        <b-thead>
                                            <b-tr>
                                                <b-th>{{$t('invoicerecognition.eigenschap')}}</b-th>
                                                <b-th>{{$t('invoicerecognition.waarde')}}</b-th>
                                            </b-tr>
                                        </b-thead>
                                        <b-tbody>
                                            <b-tr>
                                                <b-td>{{$t('invoicerecognition.id')}}</b-td>
                                                <b-td>{{ invoicerecognitionitem.id }}</b-td>
                                            </b-tr>                                            
                                            <b-tr>
                                                <b-td>{{$t('invoicerecognition.documentid')}}</b-td>
                                                <b-td>{{ invoicerecognitionitem.documentId }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{$t('invoicerecognition.bestandsnaam')}}</b-td>
                                                <b-td>{{ invoicerecognitionitem.filename }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{$t('invoicerecognition.documenttype')}}</b-td>
                                                <b-td>{{ invoicerecognitionitem.documentType }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{$t('invoicerecognition.zekerheid')}}</b-td>
                                                <b-td>{{ invoicerecognitionitem.confidence }}</b-td>
                                            </b-tr>                                            
                                        </b-tbody>
                                    </b-table-simple>
                                    <b-table-simple responsive style="width: 100%" class="d-xs-block d-sm-block d-md-block d-lg-none">
                                        <b-tbody>                                        
                                            <b-tr>
                                                <b-td>{{$t('invoicerecognition.documentid')}}</b-td>
                                                <b-td>{{ invoicerecognitionitem.documentId }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{$t('invoicerecognition.documenttype')}}</b-td>
                                                <b-td>{{ invoicerecognitionitem.documentType }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{$t('invoicerecognition.zekerheid')}}</b-td>
                                                <b-td>{{ invoicerecognitionitem.confidence }}</b-td>
                                            </b-tr>                                            
                                        </b-tbody>
                                    </b-table-simple>                                    
                                    <div class="d-none d-lg-block d-xl-block">
                                        <div class="mb-3 d-flex justify-content-between">
                                            <b-button-group class="mb-3 d-flex justify-content-start">
                                                <b-button variant="secondary" v-on:click="goToPreviousDocument">
                                                    <i class="fas fa-hand-point-left mr-2"></i>{{$t('invoicerecognition.vorigDocument')}}
                                                </b-button>
                                                <b-button variant="secondary" v-on:click="goToNextDocument">
                                                    {{$t('invoicerecognition.volgendDocument')}}<i class="fas fa-hand-point-right ml-2"></i>
                                                </b-button>
                                            </b-button-group>

                                            <div class="mb-3 d-flex justify-content-end ml-2">
                                                <b-button class="white--text d-flex fmcolors align-items-center" value="false" :id="this.invoicerecognitionitem.id" style="margin-left: 10px" v-on:click="markAsPositive">
                                                    <i class="fas fa-check mr-2"/> {{$t('invoicerecognition.positief')}}
                                                </b-button>
                                                <b-button class="white--text d-flex fmcolors align-items-center" value="false" :id="this.invoicerecognitionitem.id" style="margin-left: 10px" v-on:click="markAsNegative">
                                                    <i class="fas fa-check mr-2"/> {{$t('invoicerecognition.negatief')}}
                                                </b-button>                                                
                                                <b-checkbox class="d-flex align-items-center checkbox-autom" style="margin-left: -15px" v-model="swithAutomaticgoToNextDocument" v-on:click="swithAutomaticgoToNextDocument = !swithAutomaticgoToNextDocument">{{$t('invoicerecognition.automatisch')}}
                                                    <span class="ml-2"><i class="fas fa-question-circle fa-sm" @click="$bvModal.show('modal-according')"/></span></b-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-xs-block d-sm-block d-md-block d-lg-none">
                                        <div class="mb-3 d-flex justify-content-start">
                                            <b-button-group class="mb-0 justify-content-start">
                                                <b-button variant="secondary" v-on:click="goToPreviousDocument">
                                                    <i class="fas fa-hand-point-left mr-2"></i>{{$t('invoicerecognition.vorigDocument')}}
                                                </b-button>
                                                <b-button variant="secondary" v-on:click="goToNextDocument">
                                                    {{$t('invoicerecognition.volgendDocument')}}<i class="fas fa-hand-point-right ml-2"></i>
                                                </b-button>
                                                <b-button class="ml-2 white--text fmcolors validationButton-small" value="false" :id="this.invoicerecognitionitem.id" v-on:click="markAsPositive">
                                                    <i class="fas fa-check mr-2"/> {{$t('invoicerecognition.positief')}}
                                                </b-button>
                                                <b-button class="white--text fmcolors validationButton-small" value="false" :id="this.invoicerecognitionitem.id" v-on:click="markAsNegative">
                                                    <i class="fas fa-check mr-2"/> {{$t('invoicerecognition.negatief')}}
                                                </b-button>
                                                <b-checkbox class="checkbox-autom" style="margin-left: -15px" v-model="swithAutomaticgoToNextDocument" v-on:click="swithAutomaticgoToNextDocument = !swithAutomaticgoToNextDocument">{{$t('invoicerecognition.automatisch')}}
                                                    <span class="ml-2"><i class="fas fa-question-circle fa-sm" @click="$bvModal.show('modal-according')"/></span></b-checkbox>
                                            </b-button-group>
                                        </div>
                                    </div>

                                </b-row>
                            </b-container>
                        </b-tab>
                    </b-col>
                    <b-col v-if="windowSize >= 992" class="b-col-with-invoice-image px-3 d-none d-lg-block d-xl-block">
                        <DocumentImage v-bind:invoicePicture="invoicerecognitionitem.filename" />
                    </b-col>
                </b-row>
            </b-tabs>
        </transition>
    </div>
</template>

<script>
    import DocumentImage from "./DocumentImage";
    import { uuidMixin } from "@/mixins/uuidMixin";
    import $ from "jquery";
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "invoice-recognition-detail",
        mixins: [uuidMixin],
        props: {
            selectedDocumentId: null,
            selectedId: null,
            row: null
        },
        components: {DocumentImage},
        data() {
            return {
                swithAutomaticgoToNextDocument: true,
                y: 'bottom',
                x: null,
                mode: '',
                timeout: 10000,
                step: 0,
                windowSize: $(window).width()                
            }
        },
        computed: {
            ...mapGetters('fmmodule',['invoicerecognitionitem', 'invoicerecognitiondata']),
        },
        methods: {
            ...mapActions('fmmodule', ['all', 'find']),
            goToNextDocument() {
                this.expandAdditionalInfo(this.invoicerecognitionitem)
                this.$emit('nextDocument', 'next')
            },
            goToPreviousDocument() {
                this.expandAdditionalInfo(this.invoicerecognitionitem)
                this.$emit('previousDocument', 'previous')
            },
            markAsPositive() {
				this.setPositive(this.invoicerecognitionitem)
				this.$emit('documentValidation', this.invoicerecognitionitem)
                if (this.swithAutomaticgoToNextDocument) {
					this.$emit('nextDocument', 'nextWithPositiveOrNegative')
                }
            },
            markAsNegative() {
				this.setNegative(this.invoicerecognitionitem)
				this.$emit('documentValidation', this.invoicerecognitionitem)
                if (this.swithAutomaticgoToNextDocument) {
					this.$emit('nextDocument', 'nextWithPositiveOrNegative')
                }
            },            
			setPositive(invoicerecognitionitem) {
                this.$store.dispatch('fmmodule/setPositiveValidation', invoicerecognitionitem)
            },
			setNegative(invoicerecognitionitem) {
                this.$store.dispatch('fmmodule/setNegativeValidation', invoicerecognitionitem)
            },            
            expandAdditionalInfo(row) {
                var documentPatch = {
                    _showDetails: !row._showDetails
                }

                this.$store.commit('fmmodule/update', {
                    resource: "invoicerecognition/unvalidated",
                    result: { ...row, ...documentPatch }
                })             

                var rowData = `caretDown${row.documentId}`;
                this.changeCaretStyle(rowData, !row._showDetails);
            },            
            changeCaretStyle(dataa, opened) {
                if (!opened) {
                    $(`#${dataa}`).toggleClass('caretDownOpenAnimation');
                    $(`#${dataa}`).css({'transform': 'rotate(-180deg)'});
                } else {
                    $(`#${dataa}`).toggleClass('caretDownCloseAnimation');
                    $(`#${dataa}`).css({'transform': 'rotate(0deg)'});
                }
            },          
            onResize() {
                this.windowSize = $(window).width();
            }                      
        },
        created() {
            var vm = this;
            vm.find({
                resource: 'invoicerecognition/unvalidated',
                id: this.selectedId
            });
            window.addEventListener('resize', this.onResize);
        },
        destroyed() {
            window.removeEventListener('resize', this.onResize)
        },
    }
</script>

<style>
    .off {
        background-color: gray;
    }

    .on {
        color: black;
    }

    .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
        border-color: #fff #fff #dee2e6 !important;
    }

    .nav-tabs .nav-link:focus, .nav-tabs .nav-link:hover {
        border-color: #fff #fff #dee2e6 !important;
    }

    .cols{
        padding: 0 0 0 10px !important;
    }

    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }

    .v-expansion-panels {
        margin-top: 6px;    }

    .row {
        margin-right: -15px;
        margin-left: -15px;
        margin-top: 6px;
    } 

    .b-col-with-invoice-image {
        padding: 0;
    }         

    .fade-enter {
        opacity: 0;
    }

    .fade-enter-active{
        transition: opacity 2s;
    }

    .fade-leave-active{
        transition: opacity 2s;
        opacity: 0;
    }

    .checkbox-autom {
        opacity: 0;
    }
    .checkbox-autom:hover {
        opacity: 1;
    }

    .validationButton-small {
        border: 1px solid grey !important;
    }
</style>